<template>
    <div>
        <chip @click="activate" :color="props.color" :small="props.small" clickable :max-width="props.maxWidth">{{ props.text }}</chip>

		<slide-sheet v-model="isActive" :title="props.title" desktop-position="left" @closed="deactivate" :fixed-height="props.fixedHeight">
			<slot v-bind:deactivate="deactivate" v-bind:apply="apply"/>

			<template v-if="props.submitText" #footer>
				<wrapper class="p-16 border-box" stretch>
					<slot name="buttons" v-bind:deactivate="deactivate"/>
					<btn @click="apply" color="success" rounded-large>
						<Icon :icon="icons.submit"/>
						<span>{{ props.submitText }}</span>
					</btn>
				</wrapper>
			</template>
		</slide-sheet>
    </div>
</template>

<script setup lang="ts">
import Chip from "../../Chip/Chip";
import {submitIcon} from "../../../config";
import {useToggleableComponent} from "../../../composables/useToggleableComponent";
import {ToggleableComponentEmits, type ToggleableComponentProps} from "../../../types";

const props = defineProps<{
	title?: string,
	color?: string,
	text: string,
	submitText?: string,
	maxWidth?: string|number,
	small?: boolean,

	// Whether the sheet should have a fixed height of the max configured height.
	// This is required to correctly display specific scrollable components within the sheet, e.g., CalendarInput.
	fixedHeight?: boolean
} & ToggleableComponentProps>();
const emit = defineEmits([...ToggleableComponentEmits, 'open', 'cancel', 'submit']);

const {isActive} = useToggleableComponent(props, emit);

const icons = {
	submit: submitIcon,
};

function activate() {
	emit('open');
	isActive.value = true;
}

function deactivate() {
	emit('cancel');
	isActive.value = false;
}

function apply() {
	emit('submit')
	deactivate();
}
</script>